<mat-drawer-container style="height: 100%">
  <mat-drawer-content style="background: white">
    <h3>出荷実施内容</h3>
    <div class="left-pane">
      <table class="event-list">
        <thead>
        <tr>
          <th>予定日</th>
          <th>日齢</th>
          <th>対象のロット</th>
        </tr>
        </thead>
        <tbody *ngIf="selectedMeisai">
        <tr *ngFor="let event of [selectedMeisai];">
          <td>{{event?.yoteiDate}}</td>
          <td>{{event.yoteiNichirei}}</td>
          <td>{{event.taishouLotName}}</td>
        </tr>
        </tbody>
      </table>
      <br>
      <div fxLayout="row wrap" fxLayoutGap="10px">
        <mat-slide-toggle style="margin-left: 20px;" [(ngModel)]="editEvent"
                          [disabled]="!!selectedMeisai.jisshiDate">
          予定日を編集する</mat-slide-toggle>
      </div>
    </div>
  </mat-drawer-content>
  <mat-drawer style="width: 40%"opened position="end" mode="side">
    <div class="right-pane">
      <form #jisshiForm="ngForm" *ngIf="!editEvent">
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field appearance="legacy" style="padding-bottom: 10px">
            <mat-label>実施日</mat-label>
            <input matInput
                   name="jisshiDate"
                   readonly
                   [min]="registerLimitDate"
                   [max]="todayString"
                   [matDatepicker]="jisshiDatePicker"
                   [(ngModel)]="inputForm.jisshiDate"
                   (click)="jisshiDatePicker.open()"
                   (dateChange)="eventService.updateJisshiNichirei2(inputForm, edukeDate)"
                   [disabled]="!!selectedMeisai.jisshiDate && !sessionService.session.personalSetting.nabelAdmin">
            <mat-datepicker-toggle matSuffix [for]="jisshiDatePicker"></mat-datepicker-toggle>
            <mat-datepicker touchUi #jisshiDatePicker [disabled]="!!selectedMeisai.jisshiDate && !sessionService.session.personalSetting.nabelAdmin"></mat-datepicker>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施日齢
            </mat-label>
            <input matInput placeholder="実施日齢" required disabled
                   name="jisshiNichirei" type="number" [(ngModel)]="inputForm.jisshiNichirei">
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              出荷羽数
            </mat-label>
            <input matInput placeholder="出荷羽数" required min="0" type="text" inputmode="numeric" step="1"
                   name="shukkaWasuu" [(ngModel)]="shukkaWasuu" #shukkaWasuuModel="ngModel"
                   [disabled]="!!selectedMeisai.jisshiDate" [errorStateMatcher]="wasuuErrorStateMatcher" integerOnly>
            <mat-error *ngIf="shukkaWasuuModel.hasError('integerOnly')">羽数は整数で入力してください。</mat-error>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field  *ngIf="selectedMeisai.toShiyoulot && selectedMeisai.himodukiId">
            <mat-label>
              <span>出荷先ロット</span>
            </mat-label>
            <textarea matInput
                      placeholder="出荷先ロット"
                      name="shukkaSakiShiyoulotName"
                      [(ngModel)]="shukkaSakiLotInfo"
                      [disabled]="true"></textarea>
          </mat-form-field>
          <mat-form-field *ngIf="!selectedMeisai.toShiyoulot && selectedMeisai.himodukiId">
            <mat-label>
              <span>注文</span>
            </mat-label>
            <textarea matInput
                      placeholder="注文"
                      name="chumonNuber"
                      [(ngModel)]="chumonInfo"
                      [disabled]="true"></textarea>
          </mat-form-field>
        </div>
        <div fxLayout="row wrap" fxLayoutGap="10px">
          <mat-form-field>
            <mat-label>
              実施者
            </mat-label>
            <input matInput placeholder="実施者" required
                   name="jisshiSha" [(ngModel)]="inputForm.jisshiSha"
                   [disabled]="!!selectedMeisai.jisshiDate">
          </mat-form-field>
        </div>
        <br>
        <div fxLayout="row wrap" fxLayoutGap="12px" style="margin-bottom: 12px">
          <div [matTooltip]="selectedMeisai.jisshiDate ? '実施内容が登録済です。' : commonService.getAlertTooltipMessage(jisshiForm)"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="primary" [disabled]="jisshiForm.invalid || !!selectedMeisai.jisshiDate || isProcessing"
                    (click)="register();">登録
            </button>
          </div>
          <div [matTooltip]="!selectedMeisai.jisshiDate ? '実施内容が登録されていません。'
                              : registerLimitDate > selectedMeisai.jisshiDate ? NYUUKA_SHUKKA_EDITABLE_LIMIT + '日前まで取り消し可能です。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="accent"
                    [disabled]="jisshiForm.invalid || !selectedMeisai.jisshiDate || registerLimitDate > selectedMeisai.jisshiDate || isProcessing"
                    (click)="undo();">取り消し
            </button>
          </div>
          <div [matTooltip]="selectedMeisai.jisshiDate ? '実施内容を取り消してから削除してください。' : ''"
               matTooltipPosition="below"
               style="width: fit-content">
            <button mat-raised-button color="warn"
                    [disabled]="!!selectedMeisai.jisshiDate || isProcessing"
                    (click)="delete();">削除
            </button>
          </div>
        </div>
      </form>
      <div *ngIf="editEvent">
        <app-event-edit [selectedMeisais]="[selectedMeisai]"></app-event-edit>
      </div>
    </div>
  </mat-drawer>
</mat-drawer-container>
